<div class="overlay" *ngIf="show">
  <div class="center">
    <mat-progress-spinner diameter="60" mode="indeterminate">
    </mat-progress-spinner>
    {{ label }}
  </div>
</div>
